export default __webpack_public_path__ + "static/media/Landing_page1.2fad07da.jpg";